import React from 'react';

import { ArrowRight, StarGray } from '@travel/icons/ui';

import styles from './providerCommonHeaderSkeleton.module.scss';

type Props = {
  isPC?: boolean;
};

export default function ProviderCommonHeaderSkeleton({ isPC }: Props) {
  if (!isPC) {
    // SP design
    return (
      <div className={styles.skeletonWrapper} data-testid="providerCommonHeaderSkeleton-wrapper-sp">
        {/* SP Breadcrumbs */}
        <div className={styles.skeletonBreadcrumbs}>
          <span className={styles.skeletonBreadcrumbCircle40} />
          <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
          <span className={styles.skeletonBreadcrumbCircle40} />
          <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
          <span className={styles.skeletonBreadcrumbCircle100} />
          <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
          <span className={styles.skeletonBreadcrumbCircle100} />
        </div>

        {/* Hotel badge + name, circle (SP) */}
        <div className={styles.skeletonHotelSPRow}>
          <div className={styles.skeletonHotelSPCol}>
            <span className={styles.skeletonHotelBadgeSP} />
            <div className={styles.skeletonHotelNameSP} />
          </div>
          <span className={styles.skeletonHotelActionCircleSP} />
        </div>

        {/* 6 circles */}
        <div className={styles.skeletonHotelActionSPGroup}>
          {Array.from({ length: 6 }, (_, i) => (
            <span key={i} className={styles.skeletonHotelActionCircleSP} />
          ))}
        </div>
      </div>
    );
  }

  // PC design
  return (
    <div className={styles.skeletonWrapper} date-testid="providerCommonHeaderSkeleton-wrapper-pc">
      {/* Skeleton breadcrumbs */}
      <div className={styles.skeletonBreadcrumbs}>
        <span className={styles.skeletonBreadcrumbCircle100} />
        <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
        <span className={styles.skeletonBreadcrumbCircle40} />
        <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
        <span className={styles.skeletonBreadcrumbCircle40} />
        <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
        <span className={styles.skeletonBreadcrumbCircle100} />
        <ArrowRight size={12} className={styles.reviewPageLinkArrow} />
        <span className={styles.skeletonBreadcrumbCircle40} />
      </div>

      <div className={styles.hotelInfoRowSkeleton}>
        <div className={styles.hotelInfoLeftSkeleton}>
          {/* Hotel badge and name */}
          <div className={styles.skeletonHotelInfo}>
            <span className={styles.skeletonHotelBadge} />
            <div className={styles.skeletonHotelName} />
          </div>

          {/* Rating and hotel links */}
          <div className={styles.hotelInfoAndLinksSkeleton}>
            <div className={styles.skeletonRating}>
              {Array.from({ length: 5 }, (_, i) => (
                <StarGray key={i} className={styles.loadingStar} size={16} />
              ))}
            </div>
            <div className={styles.skeletonHotelLinksGroup}>
              <span className={styles.skeletonHotelLink100} />
              <span className={styles.skeletonHotelLink222} />
              <span className={styles.skeletonHotelLink222} />
            </div>
          </div>

          {/* Badges */}
          <div className={styles.skeletonBadgesGroup}>
            {Array.from({ length: 4 }, (_, i) => (
              <span key={i} className={styles.skeletonBadgeSquare} />
            ))}
          </div>
        </div>
        <div className={styles.hotelActionSkeleton}>
          {Array.from({ length: 3 }, (_, i) => (
            <span key={i} className={styles.skeletonHotelActionCircle} />
          ))}
        </div>
      </div>

      {/* Tab list */}
      <div className={styles.skeletonTabListGroup}>
        {Array.from({ length: 8 }, (_, i) => (
          <span key={i} className={styles.skeletonTabListPill} />
        ))}
      </div>
    </div>
  );
}
